import React, { useState, useEffect } from "react";
import { Table, Image } from "react-bootstrap"; 
import BasicPagination from "../../../../Pagination/Pagination";
import moment from "moment";
const MiscPageComponent = (props) => {
  //state
  const [page, setPage] = useState(1);

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };
  const [referal, setReferal] = useState([]);

  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        item?._id.includes(props.search) ||
        item.referred_id?.first_name
          ?.toLowerCase()
          .includes(props.search.toLowerCase()) ||
        item.referred_id?.referee_id_Role
          ?.toLowerCase()
          .includes(props.search.toLowerCase())
      );
    });
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.enroll_date) - new Date(a.enroll_date)
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.enroll_date) - new Date(b.enroll_date)
    );
  }

  if (props.filterBy) {
    if (props?.filterBy?.role)
      filteredData = filteredData?.filter(
        (ele) => ele.referee_id_Role?.toLowerCase() == props?.filterBy?.role
      );
  }

  // if (props.sortByDay !== 4) {
  //   filteredData = filteredData.filter((item) => {
  //     return (
  //       (props.startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         props.startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= props.endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= props.endDay)
  //     );
  //   });
  // }

  // if (props.startDate && props.endDate && props.clickedSearch) {
  //   let ed = new Date(props.endDate).getTime();
  //   let sd = new Date(props.startDate).getTime();

  //   filteredData = filteredData.filter((d) => {
  //     var time = new Date(d.createdAt).getTime();
  //     return sd < time && time < ed;
  //   });
  // }
  // useEffect(() => {
  //   if (props.data) {
  //     // const items = props.data.nominations;
  //     // const reversedItems = items.map((item) => item).reverse();
  //     // setNominations(reversedItems);

  //     // let sortedDates = props.data.sort(function (a, b) {
  //     //   return new Date(b.updatedAt) - new Date(a.updatedAt);
  //     // });
  //     let sortedDates = [];

  //     if (props.sortByDate === 1) {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(b.updatedAt) - new Date(a.updatedAt);
  //       });
  //     } else {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(a.updatedAt) - new Date(b.updatedAt);
  //       });
  //     }
  //     setReferal(sortedDates);
  //   }
  // }, [props.data, props.sortByDate]);

  return (
    <>
      <div className="user-table-reusable-superadmin table-responsive">
        <Table>
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "15%" }} className="f12-700">
                Referee ID
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Referee Name
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Referee
                <br />
                Role
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Referred
                <br />
                Date
              </th>
              {/* <th style={{ width: 85 }} className="f12-700">
                Enrollment
                <br />
                Date
              </th> */}
              <th style={{ width: "10%" }} className="f12-700">
                Qualifying <br /> Activity
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Referral
                <br />
                Qualified
              </th>
              {/* <th style={{ width: 95 }} className="f12-700">
                Last Activity
                <br />
                Referree
              </th> */}
              <th style={{ width: "15%" }} className="f12-700">
                Qualifying Activity
                <br />
                Date
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Payable Amount
                <br />
                To Referrer
              </th>
            </tr>
          </thead>

          {filteredData.slice(start, end).map((refree, index) => {
            return <TableBody refree={refree} key={index} />;
          })}
        </Table>
      </div>
      {filteredData.length !== 0 ? (
        <BasicPagination
          totalRecords={filteredData.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <></>
      )}
    </>
  );
};
const TableBody = (props) => {
  let refree = props?.refree;
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  return (
    <>
      <tbody
      //  className="HideShowTable"
      >
        <tr className="super_admin_all_users_table_body">
          <td colSpan="6" className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr
                  className="super_admin_all_users_table_body super_admin_user_view_inside_table_body py-3"
                  onClick={showTr}
                >
                  <td style={{ width: "15%" }}>
                    <div className="f12-400 text-break">{refree?._id}</div>
                  </td>
                  {/* <td style={{ width: 80 }}>
                    <div className="f12-400 text-break">
                      {refree.referee_id}
                    </div>
                  </td> */}
                  <td style={{ width: "15%" }}>
                    <div className="d-flex align-items-center">
                      <div className="f12-400 pl-2">{`${
                        refree?.referred_id?.first_name || ""
                      } ${refree?.referred_id?.last_name || ""}`}</div>
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">{refree?.referee_id_Role}</div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-400">
                      {moment(refree?.updatedAt).format("Do MMMM YYYY")}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">{refree?.last_activity}</div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {refree?.referral_qualified ? "Yes" : "NO"}
                    </div>
                  </td>
                  <td style={{ width: "15%  " }}>
                    <div className="f12-400">
                      {moment(refree?.enroll_date).format("Do MMMM YYYY")}
                    </div>
                  </td>
                  {/* <td style={{ width: 95 }}>
                    <div className="f12-400">XXX</div>
                  </td> */}
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      <b>₹ </b>
                      {refree?.referralAmount || "0"}
                    </div>
                  </td>
                </tr>
                {TrDetail && (
                  <>
                    <tr
                      className="superadmin-referral-table-body"
                      style={{
                        overflowWrap: "anywhere",
                      }}
                    >
                      <td style={{ width: "20%" }} className="pl-4">
                        <div className="f12-400">
                          Payable Amount <br />
                          To Referee
                        </div>
                        <div className="f12-500">
                          ₹{refree?.refereeAmount || 0}
                        </div>
                      </td>
                      <td style={{ width: "20%" }} className="pl-4">
                        <div className="f12-400">
                          Contribution towards <br />
                          Udbhav
                        </div>
                        <div className="f12-500">₹{refree?.donation || 0}</div>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </>
  );
};
export default MiscPageComponent;
